/**
 * Created by Arif Topcu in 2019
 */

import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import "./style.css";
import Combobox from "@ls/react-combobox-grid";
import { Cell, Grid } from "styled-css-grid";
import {
  selectAttributeValuesSelectionOptions,
  selectFetchingAttributeValues,
} from "state/attributes/selectors";
import { useSelector } from "react-redux";

const AttributesSelectorComplication = ({ setDefinition, definition }) => {
  const attributeOptions = useSelector(selectAttributeValuesSelectionOptions);
  const fetchingAttributeValues = useSelector(selectFetchingAttributeValues);

  const [setAttribute] = useMemo(() => {
    return [(value) => setDefinition(definition.setAttribute(value))];
  }, [definition, setDefinition]);

  return (
    <Grid columns={1} gap="4px">
      <Cell>
        <Combobox
          options={attributeOptions}
          onChange={setAttribute}
          isLoading={fetchingAttributeValues}
          value={definition.attribute}
          label="Attribute:"
          variation={0}
          size={"S"}
          gridHeight={175}
        />
      </Cell>
    </Grid>
  );
};

AttributesSelectorComplication.propTypes = {
  setDefinition: PropTypes.func.isRequired,
  definition: PropTypes.object.isRequired,
};

export default memo(AttributesSelectorComplication);
